import { GlobalService } from "src/app/_services/global.service";
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map, catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
const devUrl = environment.backendurl

@Injectable({
    providedIn: 'root'
})

export class AggregateService {
    constructor(private http: HttpClient) { }

    /**
     * Method to parse the job description and fetch relevant JSON parameters.
     * @param description The job description to be parsed.
     * @returns An observable containing the parsed job description.
     */
    jdParser(description: string | null = null) {
        const formData: any = new FormData();
        formData.append("description", description);
        const url = devUrl + "/personsearch/jobdescription";
        return this.http.post(url, formData).pipe(map(response => { return response; })
            , catchError(GlobalService.handleError('Fetch JSON params for Job Description: ', url)));
    };

    /**
     * Fetches the list of users for the hiring project.
     * @returns An observable containing the list of users.
     */
    getHiringProjectUsersList() {
        const url = devUrl + "/hiring-project/user/list";
        return this.http.get(url).pipe(map(response => { return response; })
            , catchError(GlobalService.handleError('Fetch users list: ', url)));
    };

    /**
     * Fetches the project explanation for a candidate.
     * @param payload The payload containing the candidate information.
     * @returns An observable containing the project explanation.
     */

    getProjectExplanation(payload: any) {
        const url = devUrl + "/aisourcing/candidate/explanation";
        return this.http.post(url, payload).pipe(map(response => { return response; })
            , catchError(GlobalService.handleError('Fetch project explanation: ', url)));
    };

    /**
     * Fetches the pipeline recommendations for a project.
     * @param projectnumber The project number for which to fetch recommendations.
     * @returns An observable containing the pipeline recommendations.
     */

    getpipelineRecommendations(projectnumber: string, currentPage: number, pageSize: number) {
       const url = devUrl + "/hiring-project/" + projectnumber + "/recommendations?page=" + currentPage + "&size=" + pageSize;
        return this.http.get(url).pipe(map(response => { return response; })
            , catchError(GlobalService.handleError('Fetch pipeline recommendations: ', url)));
    }

    /**
     * Fetches the project completion status for a specific project.
     * @param projectnumber The project number for which to fetch the completion status.
     * @returns An observable containing the project completion status.
     */
    getProjectCompletionStatus(projectnumber: string) {
        const url = devUrl + "/aisourcing/project/" + projectnumber + "/completionstatus";
        return this.http.get(url).pipe(map(response => { return response; })
            , catchError(GlobalService.handleError('Fetch project completion status: ', url)));
    }

    /**
     * Fetches the total aggregates for a project.
     * @param requestobject The request payload containing project details and aggregate type.
     * @returns An observable containing the aggregate data.
     */
    getProjectTotalAggs(requestobject: any) {
        const url = devUrl + "/hiring-project/draft/aggregates";
        return this.http.post(url, requestobject).pipe(map(response => { return response; })
            , catchError(GlobalService.handleError('Fetch project total aggregates: ', url)));
    };


    /**
     * Fetches the pipeline candidate listing for a project.
     * @param payload The payload containing the project details.
     * @returns An observable containing the pipeline candidate listing.
     */
    getPipelineCandidateListing(payload: any) {
        const url = devUrl + "/hiring-project/pipeline/listing";
        return this.http.post(url, payload).pipe(map(response => { return response; })
            , catchError(GlobalService.handleError('Fetch pipeline candidate listing: ', url)));
    }

    /**
     * Fetches the pipeline reevaluation for a project.
     * @param payload The payload containing the project details.
     * @returns An observable containing the pipeline reevaluation.
     */
    getPipelineReevaluation(payload: any) {
        const url = devUrl + "/hiring-project/pipeline/reevaluation";
        return this.http.post(url, payload).pipe(map(response => { return response; })
            , catchError(GlobalService.handleError('Fetch pipeline reevaluation: ', url)));
    }

    /**
     * Exports pipeline candidates as a CSV file. Backend decides the filename (via the
     * Content-Disposition response header) and whether to stream the file back directly or
     * deliver it by email for large exports - full HttpResponse is returned (not just the
     * body) so the caller can read that header instead of re-deriving a filename itself.
     * @param payload The payload containing the project details, scope, and filters.
     * @returns An observable containing the full HTTP response, body typed as a Blob.
     */
    exportPipelineCSV(payload: any) {
        const url = devUrl + "/hiring-project/pipeline/export-csv";
        return this.http.post(url, payload, { responseType: 'blob', observe: 'response' })
            .pipe(catchError(GlobalService.handleError('Export pipeline csv: ', url)));
    }

/**
 *
 * @param payload
 * @returns
 */
    getProjectPipelineExplanation(payload: any) {
       const url = devUrl + "/hiring-projects/pipeline/explanation";
        return this.http.post(url, payload).pipe(map(response => { return response; })
            , catchError(GlobalService.handleError('Fetch pipeline reevaluation: ', url)));

    }

  getProjectFilterApply(payload:any) {
       const url = devUrl + "/aisourcing/project/details";
        return this.http.patch(url, payload).pipe(map(response => { return response; })
            , catchError(GlobalService.handleError('Fetch pipeline reevaluation: ', url)));
  }

  getProjectRecommendCount(projectId: string) {
    const url = devUrl + "/hiring-project/" + projectId + "/recommendations/count";
    return this.http.get(url).pipe(map(response => { return response; })
        , catchError(GlobalService.handleError('Fetch project recommend count: ', url)));
  }

  initiateRerunAiScreening(projectId: string) {
    const url = devUrl + "/aisourcing/project/" + projectId + "/initiatecandidatesourcing";
    return this.http.post(url, {}).pipe(map(response => { return response; })
        , catchError(GlobalService.handleError('Initiate rerun AI screening: ', url)));
  }




};
